<template>

    <b-row>
      <b-col md="12">
        <b-card
          no-body
         
        >
            <b-card-body style="padding: 3.5rem 2rem">
  
              <b-row v-if="imagenes.length < 1">
                <v-select
                  class="col"
                  placeholder="Escribe el nombre de la imágen..."
                  v-model="selectedImagen"
                  :options="filteredImagenes"
                  label="text"
                  @search="onSearchImagenes"
                  :loading="isLoading"
                  :debounce="300"
                >
                  <template #no-options>
                    {{ noImagenesMessage() }}
                  </template>
                </v-select>
  
              </b-row>
  
              <div v-if="selectedImagen" class="my-2">
                <b-row class="my-1 d-flex align-items-center">
                  <label class="col-2">Lateralidad</label>
                  <v-select 
                    class="col-4"
                    id="v-lateralidad" 
                    v-model="selectedLateralidad"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"  
                    :options="opsLateridades"
                    label="text"  
                  />
               
                  <label class="col-2">Requiere sedación?</label>
                  <v-select 
                    class="col-4"
                    id="v-sedacion" 
                    v-model="sedacion"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"  
                    :options="optSedacion"
                    label="text"  
                  />
                </b-row>
  
                <b-row>
                  <label class="col-2">Número de Orden AS400</label>
                  <validation-provider #default="{ errors }" name="norden" class="col-6"> 
                    <b-form-input 
                      id="v-norden" 
                      :state="errors.length > 0 ? false : null" 
                      v-model="norden" 
                      type="number"   
                      @keypress="validateKeyPress('norden', $event)"
                    />
                  </validation-provider>
                </b-row>
  
                <b-row class="my-1 d-flex align-items-center">
                  <label class="col-2">Motivo de Solicitud</label>
                  <b-form-textarea 
                    class="col mx-1"
                    v-model="motivosolicitud"
                    placeholder="Escriba el motivo de la solicitud..." 
                    rows="2" 
                    no-resize
                  />
                </b-row>
  
                <b-row class="my-1 d-flex align-items-center">
                  <label class="col-2">Resumen Clínico</label>
                  <b-form-textarea 
                    class="col mx-1"
                    v-model="resumen"
                    placeholder="Escriba el resumen clínico..." 
                    rows="2" 
                    no-resize
                  />
                </b-row>
  
                <b-row class="my-2 d-flex justify-content-end">
                  <b-button 
                    variant="info" 
                    size="sm" 
                    @click="agregarImagen()" 
                    style="cursor: pointer;"
                    class="mx-1"
                  >
                    <i 
                      class="fas fa-solid fa-plus" 
                      title="Agregar Diagnostico"
                    />
                    Agregar
                  </b-button>
                </b-row>
  
              </div>
              
              
              <div v-if="imagenes && imagenes.length > 0">
                <b-row class="my-3">
  
                  <b-col>
  
                    
                    <b-table 
                      :items="imagenes" 
                      :fields="fieldsre" 
                      striped bordered
                    >
                      <template #cell(imagentext)="data">
                        {{ data.item.imagentext }} 
                      </template>
                      <template #cell(sedacion)="data">
                        {{ data.item.sedacion === '1' ? 'Si' : 'No' }} 
                      </template>
                      <template #cell(acciones)="data">
                        <div class="d-flex justify-content-end">
                          <b-button 
                            variant="primary" 
                            size="sm" 
                            style="cursor: pointer;"
                            @click="editItem(data.item, data.index)">
  
                            <font-awesome-icon 
                              icon="user-pen" 
                              style="color: rgb(253, 253, 253);" 
                            />
  
                          </b-button>
  
                          <b-button 
                            variant="danger" 
                            size="sm" 
                            style="cursor: pointer;" 
                            @click="removeImagen(data.item)"
                          >
                            <font-awesome-icon 
                              icon="circle-xmark" 
                              style="color: rgb(255, 255, 255);" 
                            />
                          </b-button>
                        </div>
                      </template>
                    </b-table>
                  </b-col> 
  
                </b-row>
  
       
              </div>
              
              <b-modal 
                id="edit-image-modal" 
                v-model="showEditImageModal" 
                title="Editar Imagen" 
                @hide="resetEditImageForm"
                ok-title="Guardar"
                @ok="onSubmitEditImage"
                cancel-title="Cancelar"
                @cancel="resetEditImageForm"
              >
                <b-form @submit.prevent="onSubmitEditImage">
                      
                  <b-form-group label-for="v-lateralidad">
                    <span>Lateralidad</span>
                    <v-select 
                      id="v-lateralidad" 
                      v-model="editImageForm.lateralidad"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"  
                      :options="opsLateridades"
                      label="text"  
                    />
                  </b-form-group>
                  <b-form-group label="Número de Orden AS400" label-for="edit-norden">
                    <b-form-input
                      id="edit-norden"
                      v-model="editImageForm.norden"
                      type="text"
                      required 
                    />
                  </b-form-group>
                  <b-form-group label="Motivo de Solicitud" label-for="edit-motivosolicitud">
                    <b-form-textarea
                      id="edit-motivosolicitud"
                      v-model="editImageForm.motivosolicitud"
                      rows="3"
                      required 
                    />
                  </b-form-group>
                  <b-form-group label="Resumen Clínico" label-for="edit-resumen">
                    <b-form-textarea
                      id="edit-resumen"
                      v-model="editImageForm.resumen"
                      rows="3"
                      required 
                    />
                  </b-form-group>
                </b-form>
              </b-modal>
  
            </b-card-body>
        
        </b-card>
      </b-col>
      <b-col class="text-right">
        <b-button class="my-3" @click="onRegisterImagenes" variant="primary">
            Editar Solicitud Imagen
        </b-button>
      </b-col>
    </b-row>
  
    
  </template>
  
  <script>
  import vSelect from 'vue-select'
  import rutas from '@/assets/utils/rutas.json';
  import 'vue-form-wizard/dist/vue-form-wizard.min.css';
  import { ValidationProvider } from 'vee-validate'
  import { mapState } from "vuex";
  import { imagenesService }       from '@/views/imagen/services';
  
  import axios from 'axios';
  import _ from 'lodash';
  
  export default {
  
    name: 'EditarSolicitudImagen',
  
    components: {
      ValidationProvider,
      vSelect,
    },
    data() {
      return {
        images:null,
        cargoUnaVez: false,
        visibleBody: false,
        sedacion: {text:'No', value:'2'},
        optSedacion: [{text:'No', value:'2'}, {text:'Si', value:'1'}],
        continuar : false,
        alertaOmitida: 0,
        selectedOption: null,
        isLoading: false,
        opsLateridades: [],
        searchFailed: false,
        searchQuery: '',
        noOptionsMessage: "Ingresa palabras clave para buscar.",
        visible: false,
        collapseItemID: '',   
        titularsel3:'',
        selectedImagen: null,
        openOnHover: this.$parent.hover,
        options: {},
        filteredImagenes: [],
        imagenes:[],
        antecedentes: [],
        motivosolicitud:'',
        resumen:'',
        norden:'',
        selectedLateralidad:null,
        titularsel2:'',
        lateralidad: null,
        signosVitalesExisten: false, // Variable para verificar si existen Signos Vitales
        // Otras propiedades para los Signos Vitales
        itemSignosVital: null,
        showEditImageModal: false,
        editImageForm: {
          lateralidad: null,
          norden: '',
          motivosolicitud: '',
          resumen: '',
        // Cualquier otro campo que necesites
        },
        editingIndex: null,
        opsMenu2: [
          { value: '0', text: 'INFORMACIÓN SOBRE LA REACCIÓN ADVERSA' },
          { value: '1', text: 'INFORMACIÓN DEL MEDICAMENTO' },
          { value: '2', text: 'DESENLACE' }
        ],
        fieldsre: [
          { key: 'imagentext', label: 'Imagen', thClass: 'text-center' },
          { key:'lateralidad', label:'Lateralidad', thClass:'text-center' },
          { key:'norden', label:'Número de Orden AS400', thClass:'text-center' },
          { key:'motivosolicitud', label:'Motivo de Solicitud', thClass:'text-center' },
          { key:'resumen', label:'Resumen Clínico', thClass:'text-center' },
          { key:'sedacion', label:'Sedacion', thClass:'text-center' },
          { key: 'acciones', label: 'acciones', sortable: true, thClass: 'text-center', tdClass: 'text-right' },
        ],
        opsMenu5:[
          { value: '0', text: 'Una vez al día' },
          { value: '1', text: 'Cada 12 horas' },
          { value: '2', text: 'Dos veces al día' }
        ],
  
        opsMenu3: [
          { value: '0', text: 'CONJUTIVITIS' },
          { value: '1', text: 'DISPLASIA CERVICAL LEVE' },
          { value: '2', text: 'PAPILOMAVIRUS ' }
        ],
      
      };
    },
    created() {
      this.debouncedGetImagenes = _.debounce((search) => this.obtenerImagenes(search), 100);
      
      this.fetchLateridades();
  
    },
    computed : {
      ...mapState({
        stImagenesList: state => state.atencionCita.imagenes.imagenesList,
        
  
      }),
    },
  
    watch :{
      stImagenesList: {
        deep: true,
        immediate: true,
        handler(newValue) {
          console.log("newValue", newValue)
          if (newValue && this.cargoUnaVez === false) { // Asegúrate de que newValue no sea null
            const copiaFiltrada = newValue
            .filter(item => item.estado === '1') // Filtramos por estado
            .map(item => ({ ...item }));
            this.imagenes = copiaFiltrada
            this.tokenEnvioImagen = this.imagenes[0].tokenEnvioImagen
            this.images = [...this.imagenes]
            this.cargoUnaVez = true
            //this.motivoConsulta = newValue;
          } else {
            //this.motivoConsulta = ''; // o el valor por defecto que desees
          }
        }
      },
  
    
    },
   
  
    methods: {

        async onRegisterImagenes() {
      
      const dataImagesLS = this.stImagenesList || [];
      console.log("estoy enviando estos datos de la imagen", dataImagesLS)
      const responseImages = await imagenesService.updateEnvio('', dataImagesLS);
      console.log("se creo envio imagenes", responseImages)
      if (responseImages) {
        await this.$swal.fire({
            icon : 'success',
            text : 'Editado correctamente'
        })

        this.$router.go(0)
      }
      
      },
      validateKeyPress(campo, event) {
       
        if (campo === "norden" && this.norden.length >= 10 && !['Backspace', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
          event.preventDefault();
        }
      },
      noImagenesMessage() {
        if (this.searchQuery.length < 4) 
          return 'Escribe más caracteres para buscar...';
  
        if (this.isLoading)  
          return 'Buscando imagenes...';
        
        if (this.searchFailed) 
          return 'Error al buscar imagenes. Intente de nuevo.';
        
        if (this.filteredImagenes.length === 0 && !this.isLoading) 
          return 'No se encontraron imagenes que coincidan con tu búsqueda';
        
        return 'Escribe para buscar imagenes...';
      },
  
      async fetchGetEstablecimiento(idCita) {
        const query = `
          query qrgetCitaById($id: String!){
                getCitaId(idCit: $id) {
                  cita {
                    id
                    fechaCita
                    horaCita
                    estado
                    establecimiento{
                      id
                    }
                  
                }
                
            }
  }
        `;
  
        const var_consulta = {
          id: String(idCita),
        };
  
        try {
          const response = await axios.post(rutas.axios + 'api', { query, variables: var_consulta });
          if (response.status === 200) {
            return response.data.data.getCitaId.cita[0].establecimiento.id;  
          }
        } catch (error) {
          console.error("Error fetching establecimiento id:", error);
          return -1;
        }
      },
      async obtenerImagenes(search) {
       
        let establecimientoId = localStorage.getItem("idEstabCita")
       
        if (search && establecimientoId !== -1) {
          try {
            const query = `
                query GetImagenes($search: String, $establecimiento: String) {
                    imagenes(search: $search, establecimiento: $establecimiento) {
                        id
                        nombre
                        codigo
                    }
                }
            `;
            const response = await axios.post(rutas.axios + 'api', {
              query,
              variables: { search: search, establecimiento: establecimientoId.toString() }
            });
            this.filteredImagenes = response.data.data.imagenes.map(item => ({
              value: item.id,
              text: `${item.nombre} - ${item.codigo}`,
              nombre: item.nombre,
              codifo: item.codigo
            }));
          } catch (error) {
            console.error("Error:", error.response ? error.response.data : error);
          }
        } else {
          this.filteredImagenes = [];
        }
      },
  
      async fetchLateridades() {
        const query = `
          query {
            allLateridades {
              id
              descripcion
              nombre
            }
          }
        `;
  
        try {
          const response = await axios.post(rutas.axios + 'api', { query });
          this.opsLateridades = response.data.data.allLateridades.map(item => ({
            value: item.id,
            text: item.nombre,
          }));
        } catch (error) {
          console.error("Error fetching especialidades:", error.response.data);
        }
      },
      
      onSearchImagenes(search, loading) {
        if (search.length > 2) {
          this.isLoading = true;
          loading(true);
          this.searchQuery = search;
          this.debouncedGetImagenes(search);
        } else {
          this.filteredImagenes = [];
          this.isLoading = false;
        }
        loading(false);
      },
      removeImagen(imagen) {
        this.$swal({
          title: '¿Estás seguro de eliminar esta imagen?',
          text: "¡No podrás revertir esta acción!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'No, cancelar'
        }).then((result) => {
          if (result.isConfirmed) {
  
            
            this.images.forEach(item => {
              if(item.imagenId === imagen.imagenId && item.norden === imagen.norden) {
                item.estado = '0'
              }
            })
            console.log("imagnes borrado", this.images)
            this.$store.commit("setImagenesList",this.images);
            
            const index = this.imagenes.indexOf(imagen);
            if (index > -1) {
              this.imagenes.splice(index, 1);
              
              
              this.$swal(
                'Eliminado!',
                'La imagen ha sido eliminada.',
                'success'
              );
            }
          }
        }).catch(error => {
          console.error("Error al eliminar la imagen:", error);
          this.$swal(
            'Error',
            'Ocurrió un error al intentar eliminar la imagen.',
            'error'
          );
        });
      },
      editItem(item, index) {
        this.editImageForm = JSON.parse(JSON.stringify(item));
        const lateralidadObj = this.opsLateridades.find(option => option.value === item.lateralidad);
        if (lateralidadObj) {
          this.editImageForm.lateralidad = lateralidadObj;
        }
        this.editingIndex = index;
        this.showEditImageModal = true;
      },
      resetEditImageForm() {
        this.editImageForm = this.getDefaultImageForm();
        this.editingIndex = null;
        this.showEditImageModal = false;
      },
      onSubmitEditImage() {
        if (this.editingIndex !== null) {
          if (!this.editImageForm.norden || !this.editImageForm.motivosolicitud || !this.editImageForm.resumen) {
            this.$swal({
              title: 'Error',
              text: 'Por favor, complete todos los campos requeridos antes de editar la imagen.',
              icon: 'warning',
              confirmButtonText: 'Ok'
            });
            return; // No realiza la edición si faltan campos
          }
            
          if (!this.editImageForm.lateralidad.value ) {
            this.editImageForm.lateralidad = this.imagenes[this.editingIndex].lateralidad
          }else {
            this.editImageForm.lateralidad = this.editImageForm.lateralidad.text;
          }
          this.$set(this.imagenes, this.editingIndex, this.editImageForm);
          this.showEditImageModal = false;
          this.editingIndex = null;
          console.log("imagenes editando", this.imagenes)
          this.$store.commit("setImagenesList", this.imagenes);
          
        } else {
          console.error('Error: No hay índice de edición definido.');
        }
      },
  
  
      getDefaultImageForm() {
        return {
          selectedLateralidad: null,
          norden: '',
          motivosolicitud: '',
          resumen: '',
          // Otros campos que necesites
        };
      },
  
      async showConfirmationDialog(title, text) {
        return new Promise((resolve) => {
          this.$swal({
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'No',
            confirmButtonText: 'Sí',
            confirmButtonColor: '#d9534f',
          }).then(result => {
            
            if(result.value){
              this.alertaOmitida = 1
            }
            resolve(result.value); // Resolve con true si se presionó Sí, false si No
            
          });
        });
      },
  
      async fetchImagenesEnviadas() {
        const query = `
          query MyQuery($idpaciente : ID) {
            getImagenesenviadasIdpaciente(idpaciente: $idpaciente) {
              imagenes {
                imagen {
                  codigo
                  id
                  nombre
                  tipoImagen {
                    descripcion
                  }
                }
                fechaCreacion
                consultamedica {
                  cita {
                    doctor {
                      idPersona {
                        primerNombre
                        primerApellido
                      }
                      especialidad {
                        descripcion
                      }
                    }
                  }
                }
              }
              message
              status
            }
          }
        `;
        const idpaciente = localStorage.getItem("idPaciente")
        const variables = {
          idpaciente : idpaciente
        }
        try {
          const response = await axios.post(rutas.axios + 'api', {
            query: query,
            variables: variables
          });
  
          const respuesta = response.data.data.getImagenesenviadasIdpaciente;
          const imgenvArray = [];
  
          if (respuesta.message === "success") {
            for (let i = 0; i < respuesta.imagenes.length; i++) {
              const fechaISO = respuesta.imagenes[i].fechaCreacion;
              const dateObj = new Date(fechaISO);
              const dia = dateObj.getDate().toString().padStart(2, '0');
              const mes = (dateObj.getMonth() + 1).toString().padStart(2, '0');
              const anio = dateObj.getFullYear();
  
              const fechaFormateada = `${dia}-${mes}-${anio}`;
  
              imgenvArray.push({
                id: respuesta.imagenes[i].imagen.id,
                nombre: respuesta.imagenes[i].imagen.nombre,
                
                codigo: respuesta.imagenes[i].imagen.codigo,
                doctor: `${respuesta.imagenes[i].consultamedica.cita.doctor.idPersona.primerNombre} ${respuesta.imagenes[i].consultamedica.cita.doctor.idPersona.primerApellido}`,
                fecha: fechaFormateada
  
              });
            }
  
            const imgRepetidas = [];
            if (imgenvArray.length > 0) {
              for (let j = 0; j < imgenvArray.length; j++) {
                if (imgenvArray[j].nombre === this.selectedImagen.nombre) {
                  console.log("este es el nombre", imgenvArray[j].nombre);
                  imgRepetidas.push(imgenvArray[j]);
                }
              }
  
              if (imgRepetidas.length > 0) {
                const userConfirmed = await this.showConfirmationDialog(
                  'Imágen(es) ya enviada(s)',
                  `La imagen <<${imgRepetidas[0].nombre}>>, ya fue enviado en el ultimo mes, el dia <<${imgRepetidas[0].fecha}>>, por el doctor <<${imgRepetidas[0].doctor}>> ¿Desea continuar?`
                );
  
                this.continuar = userConfirmed;
              } else {
                this.continuar = true;
              }
            } else {
              this.continuar = true;
            }
          }
        } catch (error) {
          console.error("este es el error", error);
        }
      },
  
      async agregarImagen() {
        if (!this.selectedImagen || !this.norden || !this.selectedLateralidad || !this.motivosolicitud || !this.resumen) {
          this.$swal({
            title: 'Error',
            text: 'Por favor, complete todos los campos requeridos antes de agregar la imagen.',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        } else{
          
          this.alertaOmitida = 0
          console.log("este es el token del envio de la imagen", this.tokenEnvioImagen)
          await this.fetchImagenesEnviadas()
          if (this.continuar) {
            
            const nuevaImagen = {
              imagenId: this.selectedImagen.value,
              imagentext: this.selectedImagen.text,
              norden: this.norden,
              lateralidad: this.selectedLateralidad.text,
              lateralidadId:this.selectedLateralidad.value,
              motivosolicitud: this.motivosolicitud,
              resumen: this.resumen,
              alertaIgnorada: this.alertaOmitida,
              tokenEnvioImagen : this.tokenEnvioImagen,
              estado : '1',
              sedacion : this.sedacion.value
              
            };
            this.imagenes.push(nuevaImagen);
            this.$store.commit("setImagenesList", this.imagenes);
            this.limpiarFormulario();
          }
        }
         
      },
  
  
      limpiarFormulario() {
        this.selectedImagen = null;
        this.norden = ''; // 
        this.selectedLateralidad = null;
        this.motivosolicitud = '';
        this.resumen = '';
      },
      guardarImagenesEnviada() {
        localStorage.setItem('imagenesActual', JSON.stringify(this.imagenes));
        this.$swal({
         
          text: 'Imagenes guardadas temporalmente.',
          icon: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok'
        });
      },
  
      resetearImagenesEnviada() {
        this.$swal({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer y eliminará todas las imagenes guardados.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, resetear',
          cancelButtonText: 'No, cancelar'
        }).then((result) => {
          if (result.isConfirmed) {
            // Si el usuario confirma, resetear las recetas                
            localStorage.removeItem('imagenesActual');
            this.imagenes = [];
            // Mostrar notificación de éxito
            this.$swal({
              title: 'Reset Completo',
              text: 'Las imagenes han sido reseteadas.',
              icon: 'success',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Ok'
            });
          }
        });
      },
  
  
  
    },
    
  }
  
  
  </script>
  